// extracted by mini-css-extract-plugin
export var button = "_id-0";
export var donut = "_id-1";
export var donutFill = "_id-3";
export var donutTrack = "_id-2";